import Vue from 'vue'
import Router from 'vue-router'
import Cache from '@/utils/cache.js'

Vue.use(Router)

const routes = [
  // 根路径重定向到首页
  {
    path: '/',
    redirect: '/home'
  },
  // 首页路由
  {
    path: '/home',
    component: () => import('@/views/Home.vue'),
    meta: { layout: 'WithoutMenu' }
  },
  {
    path: '/information-detail',
    name: 'InformationDetail',
    component: () => import('@/views/pages-information/pages-information.vue'),
    meta: { layout: 'WithoutMenu' }
  },
  {
    path: '/informationFbzp',
    name: 'InformationFbzp',
    component: () => import('@/views/pages-information/information-fbzp.vue'),
    meta: { layout: 'WithoutMenu' }
  },
  // 服务相关路由 - 统一使用 WithMenu 布局
  {
    path: '/service',
    component: () => import('@/views/layouts/LayoutWithMenu.vue'),
    // meta: {  requiresAuth: true },
    // meta: { layout: 'WithMenu', requiresAuth: true },
    children: [
      {
        path: 'homePage',
        component: () => import('@/views/service/homePage/homePage.vue'),
         meta: { requiresAuth: true }
      },
      {
        path: 'memberInformation',
        component: () => import('@/views/service/memberInformation/memberInformation.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'activities',
        component: () => import('@/views/service/activities/activities.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'activities-detail',
        component: () => import('@/views/service/activities/activities-detail.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'transfer-accounts',
        component: () => import('@/views/service/components/transfer-accounts.vue'),
         meta: { requiresAuth: true }
      },
      {
        path: 'session-detail',
        component: () => import('@/views/service/activities/session-detail.vue'),
         meta: { requiresAuth: true }
      },
      // 培训相关
      {
        path: 'trainingAndLearning',
        component: () => import('@/views/service/training/training.vue'),
         meta: { requiresAuth: true }
      },
      {
        path: 'training-detail',
        component: () => import('@/views/service/training/training-detail.vue'),
         meta: { requiresAuth: true }
      },
      {
        path: 'training-session-detail',
        component: () => import('@/views/service/training/session-detail.vue'),
         meta: { requiresAuth: true }
      },
      {
        path: 'memberManagement',
        component: () => import('@/views/service/memberManagement/memberManagement.vue'),
         meta: { requiresAuth: true }
      },
      {
        path: 'changePassword',
        component: () => import('@/views/service/changePassword/changePassword.vue'),
         meta: { requiresAuth: true }
      },
      // 默认重定向
      {
        path: '',
        redirect: 'homePage'
      }
    ]
  },
  // 公共页面路由
  {
    path: '/public',
    component: () => import('@/views/layouts/LayoutWithoutMenu.vue'),
    meta: { layout: 'WithoutMenu' },
    children: [
      {
        path: 'service/login',
        component: () => import('@/views/login-regeist-page/server-login.vue')
      }
    ]
  },
  // 404 页面重定向
  {
    path: '/:pathMatch(.*)*',
    redirect: '/public/service/login'
  }
]

const router = new Router({
  base: '/website/',
  mode: 'hash',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  console.log(to, 'toooiuio')
  // 获取token判断是否已登录
  const accessToken = Cache.get('accessToken')
  
  // 需要认证的路由（service下的所有子路由）
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  
  // 排除不需要重定向的路由
  if (to.name === 'InformationDetail') {
    return next();
  }
  // 如果路由需要认证但用户未登录，则重定向到登录页
  if (requiresAuth && !accessToken) {
    // 保存用户想要访问的页面路径
    if (to.fullPath !== '/') {
      localStorage.setItem('redirectUrl', to.fullPath)
    }
    return next('/public/service/login')
  }
  // 如果已经登录并且试图访问登录页，则重定向到之前保存的页面或首页
  if (to.path === '/public/service/login' && accessToken) {
    const redirectUrl = localStorage.getItem('redirectUrl')
    if (redirectUrl) {
      localStorage.removeItem('redirectUrl')
      return next(redirectUrl)
    }
    return next('/service/homePage')
  }

  // 其他情况放行
  next()
})

export default router
